import React, { useState } from "react";
import { List, ListItem, ListItemText, Button, Box } from "@mui/material";

const PaginatedList = ({
  items,
  renderItem,
  initialCount = 5,
  loadCount = 5,
}) => {
  const [visibleCount, setVisibleCount] = useState(initialCount);

  const handleLoadMore = () => {
    setVisibleCount((prev) => Math.min(prev + loadCount, items.length));
  };

  const handleShowLess = () => {
    setVisibleCount(initialCount);
  };

  const visibleItems = items.slice(0, visibleCount);

  const isAllVisible = visibleCount >= items.length;

  return (
    <Box>
      <List dense>
        {visibleItems.map((item, index) => (
          <React.Fragment key={index}>{renderItem(item, index)}</React.Fragment>
        ))}
      </List>
      <Box textAlign="center" mt={1} display="flex" justifyContent="center" gap={1}>
        {!isAllVisible && items.length > initialCount && (
          <Button variant="outlined" size="small" onClick={handleLoadMore}>
            Voir plus
          </Button>
        )}
        {isAllVisible && items.length > initialCount && (
          <Button variant="outlined" size="small" onClick={handleShowLess}>
            Voir moins
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default PaginatedList;
